// Stub for @dgreenheck/ez-tree's `./textures` module. That module builds its texture table at IMPORT
// time (top-level `loadTexture()` calls), so merely importing EZ-Tree eagerly fetches ~2.5MB of bark +
// leaf textures. We only use EZ-Tree's GEOMETRY and texture the trees with our own materials, so we
// redirect that import here (see vite.config.ts) - returning null maps means nothing is fetched and the
// bark/leaf asset files never enter the bundle. EZ-Tree's discarded materials just get null maps.
export function getBarkTexture(): null {
  return null;
}

export function getLeafTexture(): null {
  return null;
}
